import { render, staticRenderFns } from "./commission-popup.component.vue?vue&type=template&id=664add03&scoped=true&"
import script from "./commission-popup.component.vue?vue&type=script&lang=js&"
export * from "./commission-popup.component.vue?vue&type=script&lang=js&"
import style0 from "./commission-popup.component.vue?vue&type=style&index=0&id=664add03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664add03",
  null
  
)

export default component.exports